import { Component, OnInit } from '@angular/core';
import { ContactService } from '../contact.service';
import { Observable } from 'rxjs';
import { Contact } from '../contact.model';
import { IdentityService } from 'src/app/security/identity.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-my-contacts-layout',
  templateUrl: './my-contacts-layout.component.html',
  styleUrls: ['./my-contacts-layout.component.scss']
})
export class MyContactsLayoutComponent implements OnInit {
  contacts$: Observable<Array<Contact>>;
  constructor(
    private contactService: ContactService,
    private identityService: IdentityService
  ) {}

  ngOnInit(): void {
    this.contacts$ = this.identityService.userKey$.pipe(
      switchMap(userKey => this.contactService.getContactByClient(userKey))
    );
  }
}
